import { ROLE } from '../../constants/common';
import { ROUTES } from '../../constants/routes';
import { getUserRole } from '../../utils/function';
import { stripUsernameAt } from '../../utils/usernameFormat';
import { navigateToPushLink } from './pushNavigation';

/** Whether the signed-in user can tap `@username` in a push toast. */
export const canNavigatePushUsername = () => {
  const role = Number(getUserRole());
  return (
    role === ROLE.USER ||
    role === ROLE.CREATOR_SUB ||
    role === ROLE.CREATOR_CONTENT
  );
};

/**
 * Role 2 (subscriber): creator profile. Roles 1 and 3 (creators): activity feed.
 * @param {string} username Handle with or without `@`
 */
export const navigatePushUsernameClick = (username) => {
  const bare = stripUsernameAt(username);
  if (!bare || typeof window === 'undefined') return;

  const role = Number(getUserRole());
  if (role === ROLE.USER) {
    window.location.assign(`/${encodeURIComponent(bare)}`);
    return;
  }
  if (role === ROLE.CREATOR_SUB || role === ROLE.CREATOR_CONTENT) {
    navigateToPushLink(ROUTES.ACTIVITY);
  }
};
